import React, { useEffect, useState } from 'react';
import Header from './Header';
import BannerNotice from './BannerNotice';
import LibBanner from './LibBanner';
import BannerMask from './BannerMask';
import BottomBar from '@/components/BottomBar';
import Main from './Main.tsx';
import Brand from './Brand';
import * as api from '@/api';
import { getFcmToken } from '@/utils/fcm.tsx';
import async from 'async';
import IconCountdown from './IconCountdown.tsx';
import ActivityPop from './ActivityPop.tsx';
import './index.less';
import InstallApp from './InstallApp.tsx';
import { useCommonVisible } from '@/hooks/index.tsx';
import { useNavigate, useLocation } from 'react-router-dom';
import localforage from 'localforage';
import PddContent from './PddContent.tsx';
import GuidePopup from './GuidePopup.tsx';
import DownloadPopup from './DownloadPopup.tsx';
import { ch, platform, isInBrowser, isInPWA } from '@/env';
import {
  getInstallConfig,
  getGuideConfigInfo,
  // configDetail,
  // configList,
  getBannerList,
  downloadConfigList,
  getConfigList
} from '@/api';
import { installConfig } from '@/api/interface';
// import qs from 'qs';
// import { isInstallPWA } from '@/utils/index.ts';
// import client from '@/utils/client.ts';
import {
  useActiveConfigList,
  useShowAnimate
} from '@/store/index.ts';
import Cookies from 'js-cookie';
import ActivityContent from './ActivityContent.tsx';
import { usePWAConfig } from '@/providers/PWA.tsx';
import LoadingAnimate from '@/components/LoadingAnimate/index.tsx';
import { useActivate } from 'react-activation';
import PhoneBindBox from './PhoneBindBox.tsx';
import classNames from 'classnames';
// import { If, Then } from 'react-if';
// import useIndexedDB from '@/utils/hooks.tsx';

const Home = () => {
  const showAnimate = useShowAnimate(state => state.showAnimate);
  const appConfig = (window as any).appConfig || {};
  const installBanner = useCommonVisible(true);
  // const [allConfigList, setAllConfigList] = useState<any>([]);
  const [allBannerList, setAllBannerList] = useState<any>({
    bigBannerList: [],
    smallBannerList: [],
    alertBannerList: []
  });
  const [downloadConfig, setDownloadConfig] = useState<any>([]);
  const { deferredPrompt, setDeferredPrompt, detectPercent, setDetectPercent } =
    usePWAConfig();

  const allConfigList = useActiveConfigList(state => state?.allConfigList);
  const updateAllConfigList = useActiveConfigList(
    state => state?.updateAllConfigList
  );
  const navigate = useNavigate();
  const { search } = useLocation();
  // const { search } = location;
  const [allGameList, setAllGameList] = useState<any>([]);
  const [gameCategorys, setGameCategorys] = useState<any[]>([]);
  // const [currentCategory, setCurrentCategory] = useState({}) as any;
  // const { data, addData } = useIndexedDB('MyDB', 'MyStore');
  // const queryParams = search;
  const urlParams = new URLSearchParams(search.split('?')[1]);
  // const searchInfo: searchData = useMemo(() => {
  //   let info = {};
  //   if (queryParams) {
  //     info = qs.parse(queryParams.split('?')[1]);
  //   }
  //   return info;
  // }, [queryParams]);

  const [isFromSite] = useState(() => {
    const isFromSite = !!sessionStorage.fromSite;
    delete sessionStorage.fromSite;
    return isFromSite;
  })

  const [configInfo, setConfigInfo] = useState<installConfig | null>(null);

  // 是否从安装包打开，platform=android
  // let inPlatform = false;
  // const isInPlatform = useMemo(() => {
  //   if (searchInfo?.platform == 'android' || searchInfo?.type == '1') {
  //     inPlatform = true;
  //   }
  //   return inPlatform;
  // }, [searchInfo]);

  // 添加indexDB 值
  // const handleAdd = async () => {

  //   await addData({
  //     id: 'homeParams',
  //     value: urlParams.toString()
  //   });
  // };
  // 有渠道的PWA配置
  const queryInstallConfig = async () => {
    const { code, data } = await getInstallConfig({ ch });
    if (code === 200) {
      if (
        data?.button === 0 &&
        // !localStorage.getItem(PWA_Installed) &&
        data?.type !== 1
      ) {
        installBanner.open();
      } else {
        installBanner.close();
      }
      setConfigInfo(data);
    }
  };
  // 无渠道的PWA配置
  const queryGuideConfigInfo = async () => {
    const { code, data } = await getGuideConfigInfo();
    if (code === 200) {
      // if (data?.button === 0 && !localStorage.getItem(PWA_Installed)) {
      //   installBanner.open();
      // } else {
      //   installBanner.close();
      // }
      setConfigInfo({ ...data, apkLink: data?.apkUrl });
    }
  };


  const queryConfigList = async () => {
    const list = await getConfigList();
    updateAllConfigList([...list]);
  };
  // 查询Banner的列表
  const queryBannerList = async type => {
    const params = new FormData();
    params.append('type', type);
    const { code, data } = await getBannerList(params);
    if (code === 200) {
      return data;
    }
    return [];
  };
  const queryAllBannerList = async () => {
    const [bigBannerList, smallBannerList, alertBannerList] = await Promise.all(
      [
        queryBannerList('BIG'),
        queryBannerList('SMALL'),
        queryBannerList('ALERT')
      ]
    );
    setAllBannerList({ bigBannerList, smallBannerList, alertBannerList });
  };

  // 获取下载配置
  const queryDownloadConfig = async () => {
    const { code, data } = await downloadConfigList();
    if (code === 200) {
      setDownloadConfig(data);
    }
  };

  useEffect(() => {
    queryAllBannerList();
    queryDownloadConfig();
  }, []);
  // 红包雨活动弹窗显隐，需要触发查询一下活动列表状态
  useEffect(() => {
    queryConfigList();
  }, []);

  useActivate(() => {
    queryConfigList();
    if (ch) {
      queryInstallConfig();
    } else {
      queryGuideConfigInfo();
    }
  });

  // useUnactivate(() => {
  //   updateAllConfigList([]);
  //   setAllConfigList([]);
  // });

  useEffect(() => {
    if (ch) {
      queryInstallConfig();
    } else {
      queryGuideConfigInfo();
    }
  }, []);

  useEffect(() => {
    api.logoutATK();
  }, []);

  useEffect(() => {
    if (
      isInPWA() ||
      platform ||
      (window.navigator as any).standalone
    ) {
      const templateParams =
        localStorage.getItem('templateParams') ||
        Cookies.get('templateParams') ||
        '';
      const homeParams =
        localStorage.getItem('homeParams') || Cookies.get('homeParams') || '';
      templateParams && navigate(`/home?${templateParams}`, { replace: true });
      homeParams && navigate(`/home?${homeParams}`, { replace: true });

      window.Notification &&
        isInPWA() &&
        Notification.requestPermission().then(() => {
          async.series([
            cb => {
              _getFcmToken().then(() => {
                cb(null);
              });
            },
            cb => {
              setTimeout(() => {
                _getFcmToken();
                cb(null);
              }, 1200);
            }
          ]);
        });
    } else {
      localStorage.setItem('homeParams', urlParams.toString());
      Cookies.set('homeParams', urlParams.toString());
      // handleAdd();
    }
  }, []);

  // useEffect(() => {
  //   if (localStorage.getItem(PWA_Installed)) {
  //     installBanner.close();
  //   } else {
  //     installBanner.open();
  //   }
  // }, [localStorage.getItem(PWA_Installed)]);

  useEffect(() => {
    getGameCategorys().then(async categorys => {
      for (const category of categorys) {
        await getGameListByCategory(category);
      }
    });
  }, []);

  useActivate(() => {
    getGameCategorys().then(async categorys => {
      for (const category of categorys) {
        await getGameListByCategory(category);
      }
    });
  });

  const getGameCategorys = async () => {
    const result = await api.getGameCategorys();
    if (result.code === 200) {
      setGameCategorys(result.data.filter(item => item.showType !== 2));
      return result.data.filter(item => item.showType !== 2);
    } else {
      return [];
    }
  };

  const getGameListByCategory = async category => {
    const result = await api.getGameListByCategory({
      category: category.id,
      pageIndex: 1,
      pageSize: category.count
    });

    if (result.code === 200) {
      setAllGameList(allGameList => {
        return [...allGameList, result.data.records].filter(
          item => item.length
        );
      });
    }
  };

  const _getFcmToken = async () => {
    const token = await getFcmToken();
    if (token!) {
      api.saveFcmToken({ token });
      localforage.setItem('base_url', import.meta.env.VITE_BASE_URL);
      localforage.setItem('token', token);
    }
  };

  return (
    <>
      {!isFromSite && showAnimate && <LoadingAnimate />}
      <div
        className={classNames('w-[393px] h-[calc(100vh-var(--vh-offset,0px))] m-auto overflow-y-auto relative', {
          'hidden': showAnimate
        })}
        id="topBar"
      >
        {isInBrowser && installBanner.visible && (
          <InstallApp
            installBanner={installBanner}
            configInfo={configInfo}
            deferredPrompt={deferredPrompt}
            setDeferredPrompt={setDeferredPrompt}
            detectPercent={detectPercent}
            setDetectPercent={setDetectPercent}
            downloadConfig={downloadConfig}
          />
        )}

        {isInBrowser && configInfo?.install ? (
          <GuidePopup
            configInfo={configInfo}
            deferredPrompt={deferredPrompt}
            setDeferredPrompt={setDeferredPrompt}
            detectPercent={detectPercent}
            setDetectPercent={setDetectPercent}
          />
        ): null}

        {isInBrowser &&
          (configInfo?.button ? configInfo?.button === 0 : true) && (
            <DownloadPopup
              installBanner={installBanner}
              configInfo={configInfo}
              deferredPrompt={deferredPrompt}
              setDeferredPrompt={setDeferredPrompt}
              detectPercent={detectPercent}
              setDetectPercent={setDetectPercent}
              downloadConfig={downloadConfig}
            />
          )}

        <Header appConfig={appConfig} gameCategorys={gameCategorys} />
        <div className="bg top-banner-frame">
          <BannerNotice allBannerList={allBannerList} />
        </div>
        <LibBanner allBannerList={allBannerList} />
        <Main allGameList={allGameList} gameCategorys={gameCategorys} />
        <Brand appConfig={appConfig} />
        <div className="relative">
          <BottomBar />
        </div>
        {/* 首充倒计时弹窗 */}
        <IconCountdown allConfigList={allConfigList} />

        {/* <RewardPop /> */}
        {/* <CashPop /> */}
        <PddContent />
        <PhoneBindBox />

        <ActivityContent />
        <ActivityPop allConfigList={allConfigList} />


        {allBannerList?.alertBannerList.length > 0 ? (
          <BannerMask allBannerList={allBannerList} />
        ) : null}
      </div>
    </>
  );
};

export default React.memo(Home);
